import PullToRefresh from './pull-to-refresh'

export default {
    install(Vue, options) {
        Vue.use(PullToRefresh, options);
    }
}